<script lang="ts">
  // The id is the ADMIN's: `$auth.user.id` is the target (AC12.4).
  import { auth } from '$lib/stores/auth';
  import { impersonationStop } from '$lib/stores/impersonationStop.svelte';
  import { Button } from '$lib/ui';
  import { t } from '$lib/i18n';
  import { UiKeys } from '@voicedojo/backend-types';

  async function onStop(): Promise<void> {
    if ($auth.status !== 'authenticated' || !$auth.user.impersonation) return;
    await impersonationStop.run($auth.user.impersonation.adminUserId, $auth.user.id);
  }
</script>

<div class="action">
  <Button
    variant="primary"
    onclick={onStop}
    disabled={impersonationStop.busy}
    aria-label={t(UiKeys.Impersonation.StopAria)}
  >
    {impersonationStop.busy
      ? t(UiKeys.Impersonation.StopStopping)
      : t(UiKeys.Impersonation.StopIdle)}
  </Button>
  {#if impersonationStop.error}
    <span class="error" role="status">{impersonationStop.error}</span>
  {/if}
</div>

<style lang="scss">
  .action {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .error {
    color: var(--color-recording-text);
    font-size: var(--text-body);
  }
</style>
